import { IntegrationsApiClient } from '@webapp/core/services/IntegrationsAPIClient/IntegrationsAPIClient.service'
import { IntegrationRepository } from './IntegrationRepository/IntegrationRepository'

export const integrationRepository = new IntegrationRepository({
  httpClient: IntegrationsApiClient,
})

export * from './IntegrationRepository/IntegrationRepository'
